import { NavElements } from "type/navigation/main_navigation.type";

export const NAV_ELEMENTS: NavElements = {
  HOME: { title: "home", path: "/" },
  ABOUT: { title: "o projektu", path: "/about" },
  COPYRIGHT: { title: "autorska prava", path: "/copyright" },
  ARTISTS: { title: "UMETNICI", path: "/artists" },
  ART_MOVEMENTS_AND_PHENOMENA: {
    title: "UMETNIČKI PRAVCI I POJAVE",
    path: "/art-movements-and-phenomena",
  },
  MUZEJ_SAVREMENE_UMETNOSTI: {
    title: "MUZEJ SAVREMENE UMETNOSTI",
    path: "/g/muzej-savremene-umetnosti",
  },

  // ADMIN_START: { title: "admin", path: "/administration", adminAccess: true },
};

export const NAV_MODE: { [key: string]: string } = {
  READ: "read",
  EDIT: "edit",
  DEFAULT: "",
};
